// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kSbk","toggleWrap":"styles_toggleWrap__YTHB8","content":"styles_content__18x4Z","selectAreaCode":"styles_selectAreaCode__1Tlnz"};